// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.body-fixed {
    position: fixed;
    width: 100%;
}

.wizard {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
}
.wizard-close-button {
    position: absolute;
    z-index: 10015;
    top: 15px;
    right: 15px;
}

[wizard-content] {
    position: relative;
    color: #fff;
}
[wizard-indicator] {
    position: absolute;
    width: 2px;
    height: 2px;
    background: #fff;
}
[wizard-indicator-line] {
    width: 1px;
    height: 1px;
    background: #fff;
}

.wizard-slide-in-right [wizard-content-container] {
    float: left;
    width: 360px;
}
.wizard-slide-in-right [wizard-content-container] h2 {
    margin-top: -8px;
}

.wizard-slide-in-bottom [wizard-content-container] {
    padding-top: 10px;
    padding-left: 10px;
    padding-right: 10px;
}
.wizard-slide-in-bottom [wizard-content-container] h2 {
    margin-top: 0;
}

.wizard-slide-in.ng-enter,
.wizard-slide-in.ng-leave {
    transition: all 0.5s ease;
    -webkit-transition: all 0.5s ease;
    -moz-transition: all 0.5s ease;
    -o-transition: all 0.5s ease;
}
.wizard-slide-in.ng-enter.ng-enter-active,
.wizard-slide-in.ng-leave {
    opacity: 1;
}
.wizard-slide-in.ng-enter,
.wizard-slide-in.ng-leave.ng-leave-active {
    opacity: 0;
}

.wizard-slide-in-bottom.ng-enter {
    margin-top: 0;
}
.wizard-slide-in-bottom,
.wizard-slide-in-bottom.ng-enter.ng-enter-active {
    margin-top: 5px;
}
.wizard-slide-in-bottom.ng-leave.ng-leave-active {
    margin-top: 20px;
}

.wizard-slide-in-right.ng-enter {
    margin-left: 0;
}
.wizard-slide-in-right,
.wizard-slide-in-right.ng-enter.ng-enter-active {
    margin-left: 5px;
}
.wizard-slide-in-right.ng-leave.ng-leave-active {
    margin-left: 20px;
}

.wizard-slide-in-left.ng-enter {
    margin-left: 0;
}
.wizard-slide-in-left,
.wizard-slide-in-left.ng-enter.ng-enter-active {
    margin-left: -5px;
}
.wizard-slide-in-left.ng-leave.ng-leave-active {
    margin-left: -20px;
}

/* Wizard target element classes */

.wizard-highlight-nav-component {
    background: #fff;
}
.wizard-highlight-form-tab {
    background: #fff;
    color: #000;
}
.wizard-highlight-form-group label {
    color: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/css/wizard.css"],"names":[],"mappings":";AACA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,SAAS;IACT,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,UAAU;IACV,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,aAAa;AACjB;;AAEA;;IAEI,yBAAyB;IACzB,iCAAiC;IACjC,8BAA8B;IAC9B,4BAA4B;AAChC;AACA;;IAEI,UAAU;AACd;AACA;;IAEI,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;AACA;;IAEI,eAAe;AACnB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;AACA;;IAEI,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;AACA;;IAEI,iBAAiB;AACrB;AACA;IACI,kBAAkB;AACtB;;AAEA,kCAAkC;;AAElC;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,WAAW;AACf","sourcesContent":["\n.body-fixed {\n    position: fixed;\n    width: 100%;\n}\n\n.wizard {\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n}\n.wizard-close-button {\n    position: absolute;\n    z-index: 10015;\n    top: 15px;\n    right: 15px;\n}\n\n[wizard-content] {\n    position: relative;\n    color: #fff;\n}\n[wizard-indicator] {\n    position: absolute;\n    width: 2px;\n    height: 2px;\n    background: #fff;\n}\n[wizard-indicator-line] {\n    width: 1px;\n    height: 1px;\n    background: #fff;\n}\n\n.wizard-slide-in-right [wizard-content-container] {\n    float: left;\n    width: 360px;\n}\n.wizard-slide-in-right [wizard-content-container] h2 {\n    margin-top: -8px;\n}\n\n.wizard-slide-in-bottom [wizard-content-container] {\n    padding-top: 10px;\n    padding-left: 10px;\n    padding-right: 10px;\n}\n.wizard-slide-in-bottom [wizard-content-container] h2 {\n    margin-top: 0;\n}\n\n.wizard-slide-in.ng-enter,\n.wizard-slide-in.ng-leave {\n    transition: all 0.5s ease;\n    -webkit-transition: all 0.5s ease;\n    -moz-transition: all 0.5s ease;\n    -o-transition: all 0.5s ease;\n}\n.wizard-slide-in.ng-enter.ng-enter-active,\n.wizard-slide-in.ng-leave {\n    opacity: 1;\n}\n.wizard-slide-in.ng-enter,\n.wizard-slide-in.ng-leave.ng-leave-active {\n    opacity: 0;\n}\n\n.wizard-slide-in-bottom.ng-enter {\n    margin-top: 0;\n}\n.wizard-slide-in-bottom,\n.wizard-slide-in-bottom.ng-enter.ng-enter-active {\n    margin-top: 5px;\n}\n.wizard-slide-in-bottom.ng-leave.ng-leave-active {\n    margin-top: 20px;\n}\n\n.wizard-slide-in-right.ng-enter {\n    margin-left: 0;\n}\n.wizard-slide-in-right,\n.wizard-slide-in-right.ng-enter.ng-enter-active {\n    margin-left: 5px;\n}\n.wizard-slide-in-right.ng-leave.ng-leave-active {\n    margin-left: 20px;\n}\n\n.wizard-slide-in-left.ng-enter {\n    margin-left: 0;\n}\n.wizard-slide-in-left,\n.wizard-slide-in-left.ng-enter.ng-enter-active {\n    margin-left: -5px;\n}\n.wizard-slide-in-left.ng-leave.ng-leave-active {\n    margin-left: -20px;\n}\n\n/* Wizard target element classes */\n\n.wizard-highlight-nav-component {\n    background: #fff;\n}\n.wizard-highlight-form-tab {\n    background: #fff;\n    color: #000;\n}\n.wizard-highlight-form-group label {\n    color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
